/*eslint-disable*/
import {mapState} from 'vuex'

export default {
  mounted () {
    this.$echo.private(`level.${this.user.id}`).listen('FinishLevel', data => {
      let level = data.level;
      if (this.level.id === level.id) {
        this.stages.forEach(stage => stage.isCompleted = true);
        this.$toasted.info(this.$i18n.t('olympiads.olympiads_finishLevelSocket_info'));
      }
    });
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  }
}